import * as LaunchDarkly from 'launchdarkly-js-client-sdk';
import { LAUNCH_DARKLY_CLIENT_ID } from '../common/constants';
import { tokenInfo } from '../lib/token';

const flagCache: { [featureKey: string]: boolean } = {};
let client: LaunchDarkly.LDClient;

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const initializeLD = async () => {
  client = LaunchDarkly.initialize(LAUNCH_DARKLY_CLIENT_ID, {
    key: tokenInfo.AccountId,
  });

  await new Promise((resolve, _reject) => {
    client.on('ready', () => {
      // @ts-expect-error -- This code was written prior to enforcing lint rules
      resolve();
    });
  });
};

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const getLDFlag = (featureKey: string, defaultValue: boolean) => {
  if (!client && process.env.JEST_WORKER_ID) {
    return defaultValue;
  }
  if (!(featureKey in flagCache)) {
    flagCache[featureKey] = client.variation(featureKey, defaultValue);
  }
  return flagCache[featureKey];
};
